import React from "react"
import { IConsultantDeclarationMensuelleFactureModel } from "@common-models/*"

interface Props {
     data: IConsultantDeclarationMensuelleFactureModel[]
     processingId: number | string | null
     isEditionModeEnabled: boolean
     onDownload: (googleDriveFileId: string, mime: string, docId: number) => void
     onDelete: (id: number) => void
}

const FacturesHistoryList = ({ data, processingId, isEditionModeEnabled, onDownload, onDelete }: Props) => {
     // Safeguard: Do not render anything if the history list is empty
     if (!data || data.length === 0) return null

     return (
          <div className="animate__animated animate__fadeIn">
               {/*<div className="separator border-2 border-secondary border-opacity-25 my-12" />*/}
               <h4 className="fw-bold text-gray-900 mb-8">
                    <i className="fas fa-history text-muted me-3" />
                    Historique des dépôts
               </h4>

               {data.map((facture, index) => {
                    const total = ((facture.montantHt || 0) + (facture.montantTva || 0)).toFixed(2)

                    // Vérification de l'existence des montants
                    const hasHt = facture.montantHt !== null && facture.montantHt !== undefined
                    const hasTva = facture.montantTva !== null && facture.montantTva !== undefined
                    return (
                         <div
                              key={facture.id}
                              className="d-flex flex-column flex-md-row align-items-md-center justify-content-between bg-body border border-secondary border-opacity-25 rounded px-5 py-4 mb-4 hover-elevate-up shadow-xs transition-all"
                         >
                              {/* Left Side: Icon, Name, and Date */}
                              <div className="d-flex align-items-center mb-3 mb-md-0 flex-grow-1">
                                   <div className="symbol symbol-40px bg-light-success border border-success border-opacity-10 me-5 d-flex align-items-center justify-content-center">
                                        <i className="fas fa-file-invoice-dollar text-success fs-5"></i>
                                   </div>
                                   <div className="d-flex flex-column me-8">
                                        <span className="text-gray-900 fw-bold fs-5">Facture n°{index + 1}</span>
                                        <span className="text-muted fs-7">{facture.createdAt?.format("DD/MM/YYYY")}</span>
                                   </div>

                                   {/* Affichage conditionnel des badges HT et TVA */}
                                   {(hasHt || hasTva) && (
                                        <div className="text-gray-600 fs-7 fw-semibold d-none d-lg-block">
                                             {hasHt && <span className="badge badge-secondary me-2">HT: {facture.montantHt?.toFixed(2)}€</span>}
                                             {hasTva && <span className="badge badge-secondary">TVA: {facture.montantTva?.toFixed(2)}€</span>}
                                        </div>
                                   )}
                              </div>

                              {/* Right Side: Total Amount and Action Buttons */}
                              <div className="d-flex align-items-center justify-content-between justify-content-md-end w-100 w-md-auto gap-3">
                                   {total && Number(total) > 0 && <span className="badge badge-light-dark fw-bolder fs-6 px-4 py-2 me-md-4">{total} €</span>}
                                   <div className="d-flex gap-2">
                                        <button
                                             className="btn btn-icon btn-sm btn-light-primary w-35px h-35px rounded-circle shadow-sm"
                                             disabled={processingId === `dl-${facture.id}`}
                                             onClick={() => onDownload(facture.googleDriveId!, facture.googleDriveMimeType!, facture.id!)}
                                        >
                                             {processingId === `dl-${facture.id}` ? (
                                                  <span className="spinner-border spinner-border-sm"></span>
                                             ) : (
                                                  <i className="fas fa-download"></i>
                                             )}
                                        </button>
                                        {isEditionModeEnabled && (
                                             <button
                                                  className="btn btn-icon btn-sm btn-light-danger w-35px h-35px rounded-circle shadow-sm"
                                                  disabled={processingId === facture.id}
                                                  onClick={() => onDelete(facture.id!)}
                                             >
                                                  {processingId === facture.id ? <span className="spinner-border spinner-border-sm"></span> : <i className="fas fa-trash"></i>}
                                             </button>
                                        )}
                                   </div>
                              </div>
                         </div>
                    )
               })}
          </div>
     )
}

export default FacturesHistoryList
